import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { FaSpinner } from 'react-icons/fa';
import { trackLandingEvent } from '../services/analytics';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 60px 20px;
  text-align: center;
`;

const LoadingIcon = styled.div`
  font-size: 2rem;
  color: #4f46e5;
  margin-bottom: 2rem;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Message = styled.p`
  font-size: 1.2rem;
  color: #666;
`;

const SubscriptionCanceled: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  
  useEffect(() => {
    trackLandingEvent('subscription_canceled_view');
    // 在组件挂载后3秒自动重定向到价格页面
    const timer = setTimeout(() => {
      navigate('/pricing');
    }, 3000);
    
    // 清理定时器
    return () => clearTimeout(timer);
  }, [navigate]);
  
  return (
    <Container>
      <LoadingIcon>
        <FaSpinner />
      </LoadingIcon>
      
      <Message>
        {t('subscriptionCanceled.message')}
      </Message>
    </Container>
  );
};

export default SubscriptionCanceled; 
